// source: pbtypes/gen/skills/ui_variable_keys.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

goog.exportSymbol('proto.skills.UiVariableKeys', null, global);
goog.exportSymbol('proto.skills.UiVariableKeys.Enum', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skills.UiVariableKeys = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skills.UiVariableKeys, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skills.UiVariableKeys.displayName = 'proto.skills.UiVariableKeys';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skills.UiVariableKeys.prototype.toObject = function(opt_includeInstance) {
  return proto.skills.UiVariableKeys.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skills.UiVariableKeys} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.UiVariableKeys.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skills.UiVariableKeys}
 */
proto.skills.UiVariableKeys.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skills.UiVariableKeys;
  return proto.skills.UiVariableKeys.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skills.UiVariableKeys} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skills.UiVariableKeys}
 */
proto.skills.UiVariableKeys.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skills.UiVariableKeys.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skills.UiVariableKeys.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skills.UiVariableKeys} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.UiVariableKeys.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.skills.UiVariableKeys.Enum = {
  INVALID: 0,
  GIMBAL_PITCH: 1,
  HEADING: 2,
  HEADING_RATE: 3,
  SMOOTH_LOOKAT: 4,
  VEL_X: 5,
  VEL_Y: 6,
  VEL_Z: 7,
  POS_X: 8,
  POS_Y: 9,
  POS_Z: 10,
  POS_VEL_FRAME: 11,
  MAX_SPEED: 12,
  AZIMUTH: 13,
  AZIMUTH_DEADZONE: 14,
  AZIMUTH_RATE: 15,
  ELEVATION: 16,
  ELEVATION_DEADZONE: 17,
  HEIGHT: 18,
  HEIGHT_DEADZONE: 19,
  RANGE: 20,
  RANGE_DEADZONE: 21,
  ZOOM: 22,
  Z_PLANE_HEIGHT: 23,
  RAY_START_X: 24,
  RAY_START_Y: 25,
  RAY_START_Z: 26,
  RAY_END_X: 27,
  RAY_END_Y: 28,
  RAY_END_Z: 29,
  PINCH_ZOOM: 30,
  GIMBAL_PITCH_RATE: 31
};

goog.object.extend(exports, proto.skills);
